<template>
  <hm-card-inner :full-size="true" :title="label">
    <hm-table :hover="false"
              :columns="`${tableHeadings.length || 1}`"
              :grid-template-columns="gridTemplateColumns || repeat('1fr ', tableHeadings.length || 1)"
              :disable-scroll="true"
              :min-width="minWidth">
      <template slot="table-head">
        <div v-for="(heading, idx) in tableHeadings" :key="idx" class="hm-table__th">{{ heading }}</div>
      </template>
      <template v-for="(value, valueIdx) in internalValue">
        <slot :value="value" :value-idx="valueIdx">
          <div v-for="idx in range(0, tableHeadings.length || 1)" :key="idx" class="hm-table__td"></div>
        </slot>
      </template>
    </hm-table>
  </hm-card-inner>
</template>

<script>
import { defineComponent } from 'vue';
import HmInputMixin from '../../../mixins/HmInputMixin';
import HmTable from '../table/HmTable.vue';
import { first, indexOf, isEmpty, range, repeat } from 'lodash';
import HmCardInner from '../layout/HmCardInner.vue';

export default defineComponent({
  name: 'DynamicTableEditor',
  components: { HmCardInner, HmTable },
  mixins: [HmInputMixin],

  props: {
    hover: {
      type: Boolean,
      default: false,
    },
    notValued: {
      type: Function,
      default: () => false,
    },
    minWidth: {
      type: String,
      default: '400px',
    },
    gridTemplateColumns: {
      type: String,
      default: null,
    },
    tableHeadings: {
      type: Array,
      default: () => ['', ''],
    },
    emptyRecord: {
      default: () => ({}),
    },
    autoExtend: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    internalValue: {
      handler: function (newVal, oldVal) {
        this.extend();
      },
      deep: true,
    },
  },

  created: function () {
    this.extend();
  },

  methods: {
    repeat,
    range,
    convertInternalValueToValue(newVal) {
      // TODO: this results in an endless loop
      // return newVal.filter(it => !this.notValued(it));
      return newVal;
    },
    extend() {
      if (this.autoExtend && this.notValued(this.emptyRecord)) {
        // this.internalValue.forEach((it) => {
        //   console.group('Record');
        //   console.log(it);
        //   console.log(this.notValued(it));
        //   console.groupEnd();
        // });
        if (this.internalValue.filter(it => this.notValued(it)).length === 0) {
          this.internalValue.push(this.emptyRecord);
        } else if (this.internalValue.filter(it => this.notValued(it)).length > 1) {
          const toDelete = first(this.internalValue.filter(it => this.notValued(it)));
          this.internalValue.splice(indexOf(this.internalValue, toDelete), 1);
        }
      }
    },
  },
});
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/lib/inputgroups/DynamicTableEditor.vue